import { BrowserModule } from '@angular/platform-browser';
import { NgModule,CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID } from '@angular/core';
import { AppComponent } from './app.component';
import { CollapseModule } from "ngx-bootstrap/collapse";
import { TabsModule } from "ngx-bootstrap/tabs";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AlertModule } from 'ngx-bootstrap/alert';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { FacebookModule } from 'ngx-facebook';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { AppRoutes } from './app.routes';
import { ProgressbarModule } from "ngx-bootstrap/progressbar";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { UsuarioResolve } from './usuario-resolve';
//import { ShowHidePasswordModule } from 'ngx-show-hide-password';
import { LoginResolve } from './resolves/login-resolve';
import { NgxStarsModule } from "ngx-stars";
import { RestriccionComponent } from './develop/restriccion/restriccion.component';
import { UsuariosResolve } from './resolves/usuario-resolve';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { esLocale } from 'ngx-bootstrap/locale';
import LocaleEsPe from "@angular/common/locales/es-PE";

defineLocale('es', esLocale);
registerLocaleData(LocaleEsPe);

import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { DatePipe, registerLocaleData } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import {NgbDatepickerModule} from '@ng-bootstrap/ng-bootstrap';
//Sesion
import { UserIdleModule } from 'angular-user-idle';
import { environment } from 'src/environments/environment';
import { SoloNumerosDosDecimalesDirective } from './util/directive/solo-numeros-dos-decimales';
import {DefaultModule} from './default/default.module';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { RECAPTCHA_V3_SITE_KEY, ReCaptchaV3Service, RecaptchaV3Module } from 'ng-recaptcha';




// import * as Sentry from "@sentry/browser";

// Sentry.init({
//   dsn: "https://c9e25ff48d99442bbf7df940ba17519a@sentry.io/1398846",
//   release: "alotaxi@2.0.1"
// });

// @Injectable()
// export class SentryErrorHandler implements ErrorHandler {
//   constructor(){

//   }

//   handleError(error){
//     Sentry.captureException(error.originalError || error);
//     throw error;
//   }
// }

@NgModule({
  declarations: [
    AppComponent,  
    SoloNumerosDosDecimalesDirective,
    RestriccionComponent,
    // ReporteAprobacionMobileComponent,
    
  
  ],
  imports: [
    DefaultModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutes,
    HttpClientModule,
    CollapseModule.forRoot(),
    TabsModule.forRoot(),
    FormsModule,
    BsDatepickerModule.forRoot(),
    BsDropdownModule.forRoot(),
    AccordionModule.forRoot(),
    ReactiveFormsModule,
    ModalModule.forRoot(),
    AlertModule.forRoot(),
    PaginationModule.forRoot(),
    FontAwesomeModule,
    BrowserAnimationsModule,
    ProgressbarModule.forRoot(),
    TooltipModule.forRoot(),
    PopoverModule.forRoot(),
    //ShowHidePasswordModule.forRoot(),
    FacebookModule.forRoot(),
    CarouselModule.forRoot(),
    ButtonsModule.forRoot(),
    NgxStarsModule,
    TimepickerModule.forRoot(),
    TypeaheadModule.forRoot(),
    NgbDatepickerModule,
    UserIdleModule.forRoot({idle: environment.TIEMPO_SESION.TIEMPO, timeout: environment.TIEMPO_SESION.TIMEOUT, ping: environment.TIEMPO_SESION.PING}),
    NgSelectModule,
    /*module router */
    //RecaptchaModule,
    //RecaptchaV3Module
  ],
  providers: [
    UsuarioResolve, 
    LoginResolve, 
    UsuariosResolve, 
    DatePipe,
    ReCaptchaV3Service,
    { provide: LOCALE_ID, useValue: "es-PE" },
    { provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.RECAPCHA.SITEKEY 
    }
  ],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA],

})
export class AppModule { }
